import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import Btn from 'components/buttons/Btn'
import * as PropTypes from 'prop-types'
import { Badge, Card, Col, Form, ListGroup, OverlayTrigger, Popover, Row, Table } from 'react-bootstrap'
import { useController, useFieldArray } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import { useAccount } from 'state/Account'
import MenuItem from 'state/models/MenuItem'
import { FMT } from 'utils'
import PriceRows from './PriceRows'

export default function PricesCard({ wildcard, form, item }) {
	const { t } = useTranslation()
	const account = useAccount()

	//TODO singlePrice's controlled input could be replaced by form.watch()?
	const { field: singlePrice }  = useController({ control: form.control, name: 'single_price' })
	const { fields: priceGroups } = useFieldArray({ control: form.control, name: 'menu_prices' })

	return <Card>
		<Card.Header>
			<Row>
				<Col><Icon icon="money-bill-wave"/>{t('Prices')}</Col>
				<Col xs="auto" className="embedded-btn">
					<OverlayTrigger trigger="click" placement="left" overlay={
						<Popover id="price-help">
							<Popover.Content>
								<p>{t('You must provide at least one price for each Menu this item should appear in.')}</p>
								<p>{t('In case of multiple prices, the Name identifies each Price, such as "Small" or "Large".')}</p>
								{!account.display_zero_dollar_items && <p>
									{account.display_zero_dollar_items === null?
										t('Lastly, {{0}} prices might get hidden from customers, depending on your Account settings.', { 0: FMT.money(0) }) :
										t('Lastly, prices can\'t be {{0}}, based on your current Account settings.', { 0: FMT.money(0) })}
									{' '}{t('CONTACT_QUESTIONS')}
								</p>}
							</Popover.Content>
						</Popover>
					}>
						<Btn variant="secondary" icon="question-circle" title="Help"/>
					</OverlayTrigger>
				</Col>
			</Row>
		</Card.Header>

		<ListGroup variant="flush">
			<ListGroup.Item>
				<Form.Switch {...singlePrice} defaultChecked={item.single_price} id="singlePrice"
				             label={<Trans>Single price <small>(per menu)</small></Trans>}/>
			</ListGroup.Item>

			{priceGroups.map((menu, menuIndex) => (
				<ListGroup.Item variant="flush" key={menu.id}>
					<Card.Title>
						<Icon icon={['far', 'book-open']} size="xs"/>
						{menu.display_name}
						{menu.tag && <Badge variant="secondary" as="small">{menu.tag}</Badge>}
					</Card.Title>

					<Table borderless size="sm">
						<thead>
							<tr>
								{!singlePrice.value?
									<th><Form.Label>{t('Name', { context: 'product' })}</Form.Label></th> : null}
								<th><Form.Label>{t('Price')}</Form.Label></th>
								<th/>
							</tr>
						</thead>

						<PriceRows {...{ wildcard, menu, menuIndex }} itemName={item.display_name}
						           singlePrice={singlePrice.value} allowedZero={account.display_zero_dollar_items ?? true}/>
					</Table>
				</ListGroup.Item>
			))}
		</ListGroup>
	</Card>
}

PricesCard.propTypes = {
	wildcard: PropTypes.bool.isRequired,
	form    : PropTypes.object.isRequired,
	item    : PropTypes.instanceOf(MenuItem), //not required as it starts off as null
}
